module.exports = __webpack_public_path__ + "static/media/P.511c446e.png";